"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Home = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Home = function Home(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3861 1.21065L2.38606 8.21065C2.14247 8.4001 2 8.69141 2 9V20C2 21.6569 3.34315 23 5 23H9H15H19C20.6569 23 22 21.6569 22 20V9C22 8.69141 21.8575 8.4001 21.6139 8.21065L12.6139 1.21065C12.2528 0.929784 11.7472 0.929784 11.3861 1.21065ZM16 21H19C19.5523 21 20 20.5523 20 20V9.489L12 3.266L4 9.488V20C4 20.5128 4.38604 20.9355 4.88338 20.9933L5 21H8V12C8 11.4872 8.38604 11.0645 8.88338 11.0067L9 11H15C15.5128 11 15.9355 11.386 15.9933 11.8834L16 12V21ZM10 21V13H14V21H10Z"
  }));
};

exports.Home = Home;